export default {
  data() {
    return {
      keydownCallbacks: []
    }
  },
  created() {
    window.addEventListener('keydown', this._keydownHandler)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._keydownHandler)
  },
  methods: {
    _keydownHandler(e) {
      for (const callback of this.keydownCallbacks) {
        if (callback.keyOptions.includes(e.key)) {
          document.activeElement.blur()
          callback.fn(e)
        }
      }
    },
    registerKeydownHandler(keyOptions, fn) {
      this.keydownCallbacks.push({keyOptions, fn})
    }
  }
}
